<template>
  <Head title="Termini e Condizioni" />

  <h2 class="text-3xl leading-tight font-bold">Termini e Condizioni</h2>
  <p class="text-lg mt-4 font-semibold">CONDIZIONI GENERALI</p>
  <p class="mt-2 leading-relaxed">
    Con le seguenti “Condizioni Generali”, Aquasport s.r.l. definisce le condizioni generali del contratto di vendita tramite prenotazione e contestuale pagamento, di Servizi promossi nell’ambito dell’attività della stessa.
  </p>
  <p class="mt-2 leading-relaxed">
    Aquasport s.r.l. (il Venditore) è particolarmente attenta alle esigenze degli utenti del presente sito. Di conseguenza, fornisce agli stessi, tramite le seguenti Condizioni Generali, una idonea informativa in relazione a tutti gli aspetti che regolano l’acquisto, tramite modalità telematiche, dei Servizi presentati sul sito, nel rispetto di quanto stabilito dal D.Lgs. 06/09/2005 n. 206 (“Codice del Consumo”), così come modificato dal D.Lgs. 21.02.2014, n. 21, emanato in attuazione della direttiva europea 2011/83/UE.
  </p>

  <p class="text-lg mt-4 font-semibold">DEFINIZIONI</p>
  <p class="mt-2 leading-relaxed">
    Aquasport società sportiva dilettantistica a responsabilità limitata sita in via Istria 9 a Terni (TR), p.iva01401630551, fornisce i Servizi indicati sul presente sito, di cui è proprietaria del nome a dominio. Aquasport s.r.l. gestisce la piattaforma di prenotazione/vendita operante sul sito.
  </p>
  <p class="mt-2 leading-relaxed">
    Sito: si intende il presente sito internet sul quale opera la piattaforma di prenotazione.
  </p>
  <p class="mt-2 leading-relaxed">
    Servizio: si intende il bene/prodotto/servizio proposto da Aquasport s.r.l. attraverso il presente sito internet.
  </p>
  <p class="mt-2 leading-relaxed">
    Cliente: s’intende la persona fisica o la persona giuridica, registrata sul sito che, inoltrando l’ordine/prenotazione, propone ad Aquasport s.r.l. di acquistare il Servizio tramite il sito e di pagarne il prezzo per mezzo della piattaforma presente sul sito stesso. Qualora il Cliente sia un consumatore di cui all’articolo 3 comma 1 del Codice del Consumo, lo stesso è soggetto a tutte le disposizioni di maggior tutela ivi previste, salvo quanto previsto dal presente contratto.
  </p>
  <p class="mt-2 leading-relaxed">
    Codice del Consumo: si intende il decreto legislativo 06/09/2005 n. 206
  </p>
  <p class="mt-2 leading-relaxed">
    Condizioni Generali: si intendono le presenti condizioni contrattuali pubblicate sul presente sito, di cui il Cliente può in qualsiasi momento prendere visione e stampare copia, che hanno per oggetto la vendita del Servizio da parte Aquasport s.r.l. al Cliente.
  </p>

  <p class="text-lg mt-4 font-semibold">CONDIZIONI</p>
  <p class="text-lg mt-4 font-semibold">1. CONDIZIONI GENERALI</p>
  <p class="mt-2 leading-relaxed">
    Le presenti Condizioni Generali costituiscono parte integrante ed essenziale del contratto di acquisto di Servizio effettuato tramite il presente contratto. L’inoltro di un ordine di acquisto di un Servizio da parte del Cliente comporta l’adesione alle presenti condizioni generali ed il Cliente dichiara d’accordo ad essere legalmente obbligato al rispetto dei termini e delle condizioni sotto riportate.
  </p>

  <p class="text-lg mt-4 font-semibold">2. OGGETTO DEL CONTRATTO</p>
  <p class="mt-2 leading-relaxed">
    La prenotazione del Servizio di “Ingresso presso la piscina comunale Conca Del Sole” a mezzo del sito internet comporta l’acquisto del Servizio stesso e dà diritto all’accesso in tale area per la fascia oraria e nel giorno prenotato per effettuare l’accesso, fatto salvo quanto previsto all’art. 3.
  </p>
  <p class="mt-2 leading-relaxed">
    In caso di conclusione del contratto attraverso il sito internet, il cliente conferma di avere letto e accettato le Condizioni Generali, di avere letto e accettato l’Informativa privacy, di avere letto e accettato il regolamento interno.
  </p>

  <p class="text-lg mt-4 font-semibold">3. PRENOTAZIONE DEL SERVIZIO</p>
  <p class="mt-2 leading-relaxed">
    In fase di acquisto del Servizio, a mezzo del sito internet, è necessario verificare di avere compilato correttamente tutti i campi prima di procedere all’invio della prenotazione.
  </p>
  <p class="mt-2 leading-relaxed">
    Aquasport s.r.l. si riserva il diritto di controllare i dati forniti dal potenziale Cliente e di respingere a sua insindacabile discrezione la domanda di prenotazione in presenza di validi e giustificati motivi.
  </p>
  <p class="mt-2 leading-relaxed">
    Per ogni acquisto viene generata una mail di conferma con inclusi tutti i termini della prenotazione e non occorre contattare ulteriormente la piscina comunale Conca Del Sole.
  </p>
  <p class="mt-2 leading-relaxed">
    La prenotazione del Servizio viene definita per posto-ombrellone e per un numero di persone massimo per ogni ombrellone.
  </p>
  <p class="mt-2 leading-relaxed">
    La prenotazione del Servizio non dà diritto di scegliere il posto.
  </p>
  <p class="mt-2 leading-relaxed">
    Tutti i clienti che acquistano il Servizio dichiarano formalmente di essere maggiori di età e di possedere capacità di intendere e di volere.
  </p>
  <p class="mt-2 leading-relaxed">
    La prenotazione non è nominativa. Ne consegue che l’accesso all’area prenotata può essere effettuata da terzi che non siano il Cliente, purché siano in possesso del titolo di prenotazione del servizio. In tal caso, assumono tutti gli obblighi del Cliente.
  </p>
  <p class="mt-2 leading-relaxed">
    Il Cliente dovrà presentarsi all’ingresso della piscina mostrando il titolo di prenotazione e pagamento del Servizio effettuato, tramite stampa o visualizzazione di adeguato device (smartphone, tablet ecc..)
  </p>
  <p class="mt-2 leading-relaxed">
    Il Cliente che prenota la giornata intera deve entrare entro e non oltre le ore 12.00 della giornata. In caso di mancata presentazione entro l’orario stabilito il posto verrà perso e si entra in base alla disponibilità del momento. Non sono previsti rimborsi per questa situazione.
  </p>
  <p class="mt-2 leading-relaxed">
    Tuttavia il Cliente ha la possibilità di modificare il giorno di utilizzo entro le ore 12:00 del giorno inizialmente prenotato, previa comunicazione a mezzo email all’indirizzo, consultabile sul sito di Aquasport s.r.l.
  </p>

  <p class="text-lg mt-4 font-semibold">4. OBBLIGHI DEL CLIENTE</p>
  <p class="mt-2 leading-relaxed">
    Subito prima del pagamento del Servizio il Cliente dovrà accettare le presenti condizioni di contratto e dichiarare di avere preso visione ed accettato il regolamento interno.
  </p>
  <p class="mt-2 leading-relaxed">
    Il Cliente dovrà osservare il regolamento interno ed in particolare
  </p>
  <ul class="mt-2 leading-relaxed list-disc ml-5">
    <li>mostrare il dovuto rispetto per gli altri clienti ed il personale della piscina comunale Conca Del Sole;</li>
    <li>non introdurre nella zona della piscina droghe o alcolici;</li>
    <li>non utilizzare alcuna struttura del centro durante il periodo in cui egli soffre di infezioni o malattie contagiose o altri disturbi fisici quali ferite aperte, abrasioni, piaghe aperte o infezioni che comportino rischi per la salute la sicurezza e l’igiene degli altri clienti.</li>
  </ul>
  <p class="mt-2 leading-relaxed">
    La mancata osservanza delle norme di regolamento prevede l’allontanamento dall’area piscina senza alcun rimborso.
  </p>
  <p class="mt-2 leading-relaxed">
    Il Cliente si impegna inoltre ad osservare tutte le normative in vigore.
  </p>

  <p class="text-lg mt-4 font-semibold">5. PAGAMENTI. RIMBORSI. CHIUSURA DELLA PISCINA</p>
  <p class="mt-2 leading-relaxed">
    Per il saldo della prenotazione del Servizio verrà richiesto il metodo di pagamento con carta di credito, a mezzo della infrastruttura di pagamento per Internet Stripe (www.stripe.com). L’applicazione della modalità di pagamento è comunque soggetta all’accettazione dell’ente emittente la carta di credito/banca, nonché alla circostanza che il pagamento vada a buon fine e/o e la modalità di pagamento non sia stata revocata. Per il pagamento del Servizio il Cliente autorizza ad addebitare il corrispettivo tramite il metodo di pagamento prescelto.
  </p>
  <p class="mt-2 leading-relaxed">
    Il Cliente viene trasferito su un sito protetto e i dati della carta di credito vengono comunicati direttamente all’Istituto Bancario che si occupa dei pagamenti per conto di Aquasport s.r.l.. I dati trasmessi vengono inviati in modalità protetta, mediante il trasferimento crittografato dei dati con sistema SSL (SecureSocketLayer). Tali dati non sono accessibili nemmeno per Aquasport s.r.l..
  </p>
  <p class="mt-2 leading-relaxed">
    Il corrispettivo sarà corrisposto in unica soluzione, al momento dell’acquisto, ai prezzi stabiliti dal seguente listino in vigore per l’apertura estiva 2024:
  </p>
  <ul class="mt-2 leading-relaxed list-disc ml-5">
    <li>Giornaliero 10 Euro</li>
    <li>Pomeridiano 7 Euro</li>
    <li>Lettino 3 Euro</li>
    <li>Pacchetto tendoni (2 ingressi+ 2 lettini+ 1 copertura tendone bordo vasca) 30 Euro</li>
    <li>Pacchetto fuori bordo vasca I e II anello (1 ombrellone+ 2 lettini+ 2 ingressi) 26 Euro</li>
  </ul>
  <p class="mt-2 leading-relaxed">
    La mancata presentazione nel giorno e nell’orario prenotato non dà diritto ad alcun rimborso.
  </p>
  <p class="mt-2 leading-relaxed">
    Il pagamento è contestuale all’acquisto tramite il presente sito. Il documento fiscale (scontrino fiscale) viene emesso e consegnato contestualmente alla fruizione del Servizio direttamente presso la piscina comunale Conca Del Sole.
  </p>
  <p class="mt-2 leading-relaxed">
    Non è previsto un diritto di recesso dall’acquisto per il Cliente ove questo sia avvenuto con prenotazione del Servizio per una specifica data.
  </p>
  <p class="mt-2 leading-relaxed">
    L’avvenuto pagamento del Servizio non dà diritto ad alcun rimborso salvo in caso di chiusura della piscina imputabile a maltempo, a motivazioni interne di Aquasport s.r.l. o a qualunque altra ipotesi di forza maggiore, quali guasti tecnici, impianti in avaria, ripristino urgenteo manutenzione straordinaria. Ne consegue che se la piscina non è chiusa, il rimborso del costo del Servizio non potrà essere richiesto.
  </p>
  <p class="mt-2 leading-relaxed">
    In caso di chiusura della piscina, il Cliente prenotato dovrà contattare la segreteria della medesima per richiedere una nuova data di prenotazione, nei limiti di disponibilità dei posti per altre date, con sconto equivalente al pagamento effettuato, oppure il rimborso del corrispettivo pagato.
  </p>

  <p class="text-lg mt-4 font-semibold">6. PARCHEGGI</p>
  <p class="mt-2 leading-relaxed">
    I parcheggi di cui la piscina comunale Conca Del Sole sia eventualmente dotata sono incustoditi. Pertanto, Aquasport s.r.l. non risponde dei danni o furti di cui siano oggetto i veicoli di proprietà del Cliente o i beni in essi contenuti.
  </p>

  <p class="text-lg mt-4 font-semibold">7. RESPONSABILITÀ</p>
  <p class="mt-2 leading-relaxed">
    Aquasport s.r.l. non assume alcuna responsabilità per le conseguenze fisiche e/o patrimoniali che il Cliente dovesse subire a seguito dell’esercizio delle attività connesse al Servizio, ad eccezione dei casi di comprovato dolo o colpa grave di Aquasport s.r.l..
  </p>
  <p class="mt-2 leading-relaxed">
    In particolare, Aquasport s.r.l. non è responsabile nei confronti del Cliente per i danni derivanti:
  </p>
  <ul class="mt-2 leading-relaxed list-disc ml-5">
    <li>da un comportamento del Cliente contrario alle norme di legge od alle presenti condizioni generali;</li>
    <li>da un comportamento del Cliente contrario alle normali regole di prudenza;</li>
    <li>da azioni od omissioni di terzi salvo se dovute a dolo o colpa grave di Aquasport s.r.l.;</li>
    <li>da cause di forza maggiore al di là del ragionevole controllo di Aquasport s.r.l.;</li>
    <li>da furto, perdita o danneggiamento di denaro o beni di proprietà del Cliente. Il cliente prende e dà atto che Aquasport s.r.l. non è custode dei beni e/o valori portati all’interno dell’area piscina/parcheggio.</li>
  </ul>

  <p class="text-lg mt-4 font-semibold">8. PRIVACY. TRATTAMENTO DEI DATI PERSONALI</p>
  <p class="mt-2 leading-relaxed">
    Consultabile nell’apposita sezione del presente sito internet.
  </p>

  <p class="text-lg mt-4 font-semibold">9. DISPOSIZIONI FINALI</p>
  <p class="mt-2 leading-relaxed">
    Aquasport s.r.l. si riserva il diritto di modificare in ogni momento le presenti Condizioni Generali, a propria discrezione e senza preavviso. Eventuali modifiche si applicheranno esclusivamente alle vendite concluse a partire da tale data.
  </p>
  <p class="mt-2 leading-relaxed">
    Il contratto e le presenti condizioni generali sono interamente regolati dalla legge italiana.
  </p>
  <p class="mt-2 leading-relaxed">
    Ai sensi e per gli effetti di cui agli articoli 1341 1342 codice civile, il cliente dichiara di avere letto, di avere compreso e di accettare le disposizioni di cui ai seguenti articoli delle presenti Condizioni Generali: articolo 2 (oggetto del contratto), articolo 3 (prenotazione del servizio), articolo 4 (obblighi del cliente), articolo 5 (pagamenti rimborsi chiusura della piscina), articolo 6 (parcheggi), articolo 7 (responsabilità).
  </p>
</template>

<script>
import PageLayout from "@/Pages/Home/Shared/PageLayout.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Head,
  },
  layout: PageLayout,
};
</script>
